import $ from "jquery"
import PDFSettingsPreview from "../pdfSettingsPreview/PDFSettingsPreview";

export default class BaseReportPDFSettingsPreview extends PDFSettingsPreview {
    constructor($containerEl, lightboxId, eventNamespace) {
        super($containerEl, lightboxId);
        this.eventNamespace = eventNamespace;
    }

    afterRender() {
        PDFSettingsPreview.prototype.afterRender.call(this);
        $(document.getElementById(this.lightboxId + "_numberOfPages")).hide();
    }

    subscribeToEvents() {
        PDFSettingsPreview.prototype.subscribeToEvents.call(this);

        var self = this;
        $(document).on(this.eventNamespace + ".pdfPreview.lightbox.show", function() {
            self.update();
            var printParametersForGenerate = self.collectPrintParametersForGenerate();
            self.triggerIntermediatePrintParametersChange(printParametersForGenerate);
            self.triggerPrintParametersForGenerateChange(printParametersForGenerate);
        })
    }

    unsubscribeFromEvents() {
        PDFSettingsPreview.prototype.unsubscribeFromEvents.call(this);
        $(document).off(this.eventNamespace + ".pdfPreview.lightbox.show");
    }

    updateNumberOfPagesInformation() {
        // do nothing
    }

    triggerPrintParametersForSaveChange(printParametersForSave) {
        $(document).trigger(this.eventNamespace + ".pdfPreview.printParametersForSaveChange", printParametersForSave);
    }

    triggerPrintParametersForGenerateChange(printParametersForGenerate) {
        $(document).trigger(this.eventNamespace + ".pdfPreview.printParametersForGenerateChange", printParametersForGenerate);
    }
} 


// WEBPACK FOOTER //
// ./web/js/reports/BaseReportPDFSettingsPreview.js